import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { RoomRoofHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomRoofHeatLossDetailsFormModel';

export type CreateUpdateRoomRoofHeatLossDetailsDto = {
  displayIndex: number;
  maximumVaultHeightInMetres: number | null;
  roomAreaCoveredPercentage: number | null;
  additionalRoomVolumeInMetresCubed: number | null;
  skylightAreaInMetresSquared: number | null;
  temperatureAboveInDegreesCelsius: number | null;
};

export const mapRoomRoofHeatLossDetailsFormModelToDto = (
  formModel: RoomRoofHeatLossDetailsFormModel,
  displayIndex: number,
): CreateUpdateRoomRoofHeatLossDetailsDto => ({
  displayIndex,
  maximumVaultHeightInMetres: assertIsNumberOrNull(formModel.maximumVaultHeightInMetres),
  roomAreaCoveredPercentage: assertIsNumberOrNull(formModel.roomAreaCoveredPercentage),
  additionalRoomVolumeInMetresCubed: assertIsNumberOrNull(formModel.additionalRoomVolumeInMetresCubed),
  skylightAreaInMetresSquared: assertIsNumberOrNull(formModel.skylightAreaInMetresSquared),
  temperatureAboveInDegreesCelsius: assertIsNumberOrNull(formModel.temperatureAboveInDegreesCelsius),
});
